import * as React from 'react';
import { MonthNavigationProps } from '../../custom/components/month-navigation/month-navigation';
import moment = require('moment');


const momentFormat = 'YYYY-MM';

const MonthNavigationView: React.StatelessComponent<MonthNavigationProps> = props => {

    function goToMonthChange(evt: React.MouseEvent<HTMLButtonElement>, next: boolean) {
        const momentMonths = props.filteredMonths && props.filteredMonths.length > 0 ? props.filteredMonths.split(',').map(a => moment(`1 ${a}`, "D MMMM YYYY")) : [];
        if (momentMonths.length > 0) { 
            const nextMonths = momentMonths.filter(a => a.isAfter(props.currentMonth)).sort((a, b) => { return a.isBefore(b) ? -1 : 1 });
            const prevMonths = momentMonths.filter(a => a.isBefore(props.currentMonth)).sort((a, b) => { return a.isBefore(b) ? -1 : 1 });
            props.goToMonth(next ? nextMonths[0] : prevMonths[prevMonths.length-1]);
        } else {
            const newMonth = next ? props.currentMonth.add(1, "month") : props.currentMonth.subtract(1, "month")
            props.goToMonth(newMonth);
        }
    }
    const currentMonth = moment(props.currentMonth);
    let disablePrev = currentMonth.subtract(1, "month").isBefore(props.validMonths[0]);
    currentMonth.add(1, "month");
    let disableNext = currentMonth.add(1,"month").isAfter(props.validMonths[props.validMonths.length - 1]);
    const momentMonths = props.filteredMonths && props.filteredMonths.length > 0 ? props.filteredMonths.split(',').map(a => moment(`1 ${a}`, "D MMMM YYYY")) : [];
    if (momentMonths.length > 0) {
        const nextMonths = momentMonths.sort((a, b) => { return a.isBefore(b) ? -1 : 1 });;
        if (nextMonths[0].isSame(props.currentMonth, "month")) disablePrev = true;
        if (nextMonths[nextMonths.length - 1].isSame(props.currentMonth, "month")) disableNext = true;
    }
    const disableNav = disablePrev && disableNext;
    const disableNavCssClass = (disableNav) ? "ace-cal-month-nav-hide" : "";
    return (
        <div className={`ace-cal-month-nav ${disableNavCssClass}`}>
            <button disabled={disablePrev} onClick={evt => goToMonthChange(evt, false)} className="un-btn prev">
                <svg aria-hidden="true" dangerouslySetInnerHTML={{ __html: '<use xlink:href="#icon-chevron" />' }} />
                <span className="visually-hidden">Display previous month</span>
            </button>
            <button disabled={disableNext} onClick={evt => goToMonthChange(evt, true)} className="un-btn next">
                <svg aria-hidden="true" dangerouslySetInnerHTML={{ __html: '<use xlink:href="#icon-chevron" />' }} />
                <span className="visually-hidden">Display next month</span>
            </button>
        </div>
    );
}

export default MonthNavigationView;